import axios from 'axios'
import {
    ActivationObject,
    UpdateActivationObject,
} from '../../components/providers/ActivationObjectProvider/types'
import { getRestApiConfig } from '../config'
import { AxiosErrorResult } from '../errors'
import { ApiInterests, ApiPutInterests } from './types'

export const getActivationObject = async (
    synonym?: string,
): Promise<ActivationObject> => {
    const restApiConfig = getRestApiConfig()
    const endpointUrl = new URL(
        `/api/v1/ObjectReactivation?synonym=${synonym}`,
        restApiConfig.baseUrl,
    ).href
    const response = await axios.get<ActivationObject>(endpointUrl, {
        headers: { ...restApiConfig.authHeader },
    })
    return {
        ...response.data,
        loadedAt: new Date(),
    }
}

export const postActivationObject = async (
    synonym: string,
): Promise<ActivationObject> => {
    const restApiConfig = getRestApiConfig()
    const endpointUrl = new URL(
        `/api/v1/ObjectReactivation`,
        restApiConfig.baseUrl,
    ).href
    const response = await axios.post<ActivationObject>(
        endpointUrl,
        { synonym },
        { headers: { ...restApiConfig.authHeader } },
    )
    return response.data
}

export const putActivationObject = async (object: UpdateActivationObject) => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(
            `/api/v1/ObjectReactivation`,
            restApiConfig.baseUrl,
        ).href
        const response = await axios.put<ActivationObject>(
            endpointUrl,
            {
                ...object,
            },
            { headers: { ...restApiConfig.authHeader } },
        )
        return response.data
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}

export const getInterests = async (synonym?: string): Promise<ApiInterests> => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(
            `/api/v1/ObjectReactivation/Interests?synonym=${synonym}`,
            restApiConfig.baseUrl,
        ).href
        const response = await axios.get<ApiInterests>(endpointUrl, {
            headers: { ...restApiConfig.authHeader },
        })
        return response.data
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}

export const putInterests = async (data: ApiPutInterests) => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(
            `/api/v1/ObjectReactivation/Interests`,
            restApiConfig.baseUrl,
        ).href
        const response = await axios.put<ApiInterests>(
            endpointUrl,
            { ...data },
            { headers: { ...restApiConfig.authHeader } },
        )
        return response.data
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}

export const putFinish = async (synonym: string): Promise<ActivationObject> => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(
            `/api/v1/ObjectReactivation/Finish?synonym=${synonym}`,
            restApiConfig.baseUrl,
        ).href
        const response = await axios.put<ActivationObject>(
            endpointUrl,
            { synonym },
            { headers: { ...restApiConfig.authHeader } },
        )
        return response.data
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}
